<template>
  <div class="tkCmp full-height linear-main3">
    <ld-header
      @click-left="bock()"
      :transparent="true"
      :white="true"
      :title="$t('A127','预订完成')"
    />
    <div class="pad-8">
      <div
        class="pad-b-5"
        v-for="(info,index) in flights"
        :key="index"
      >
        <div class=" pad-8 pad-b-20 white">
          <div class="font24 font-lg pad-b-5">
            <ld-icon
              :type="info.realOrderStatus!=1&&info.isShowApproval ? 'iconshenpi1' :
              detail.isShowPay == 1 ? 'iconzhifu' :
              'icondingzuoshj-icon-Reser'"
              size="30"
              class="order-status__icon"
            />
            {{ info.orderStatusRemark }}
          </div>
          <p v-show="info.realOrderStatus==1">
            {{ $t('C417','特别提示') }}！
          </p>
          <p v-show="info.realOrderStatus==1">
            您本次预订占座未成功，需要向航空公司申请座位，请等待服务商回复。如有疑问，请致电服务商咨询!
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&!info.isShowApproval"
          >
            {{ $t('H204','订单已成功提交') }}！
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&info.isShowApproval"
          >
            预订成功，请及时送审!
          </p>
          <p
            class="pad-b-5"
            v-show="info.realOrderStatus!=1&&!info.isShowApproval"
          >
            出票情况以收到短信为准!
          </p>
        </div>

        <div class="pad-b-5">
          <van-cell>
            {{ $t('F001','订单号') }}：{{ info.orderNo }}
            <span
              class="fr main-color"
              @click="toDetail(info.id)"
            >{{ $t('B011','查看订单') }}</span>
          </van-cell>
        </div>
        <div
          class="pad-b-5"
          v-for="(item,index1) in info.orderRangeBeanList"
          :key="index1"
        >
          <voyage
            :flight="item"
            :show-rule="true"
          />
        </div>
        <van-cell>
          {{ $t('C001','乘机人') }}：{{ info.orderPsgBeanList|getName }}
        </van-cell>
      </div>
      <!--  -->
      <ld-button
        class="mt5"
        detault
        to="/tk/tkQuery"
      >
        {{ $t('B012','继续预订') }}
      </ld-button>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="bg-white full-width shadow"
        type="flex"
        align="center"
      >
        <van-col span="1" />
        <van-col span="10">
          <span class="font12 money-color">&yen; </span>
          <span class="font22 money-color"> {{ detail.totalPrice }}</span>
          <span class="font10 gray"> {{ $t('E017','共') }}{{ detail.orderPsgBeanList.length }}人</span>
          &nbsp;
          <span
            class="font12 text-center"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </span>
        </van-col>
        <van-col span="6" />
        <van-col
          span="6"
          v-if="detail.isShowPay"
        >
          <ld-button
            size="md"
            main
            @click="toPay(detail.id)"
          >
            立即支付
          </ld-button>
        </van-col>
        <van-col
          span="6"
          v-if="detail.isShowApproval"
        >
          <ld-button
            main
            size="md"
            @click="sendApproval(detail)"
          >
            立即送审
          </ld-button>
          <!-- <ld-button
            v-show="detail.isShowCancel"
            defaults
            size="md"
            @click="cancel()"
          >
            取消
          </ld-button> -->
        </van-col>
        <van-col span="1" />
      </van-row>
    </ld-tabbar>
    <!-- 支付 -->
    <!-- <ld-pay
      ref="pay"
      order-type="11004"
      :order-id="orderId"
    /> -->
  </div>
</template>

<script>
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import voyage from 'Components/tk/voyage/voyage.vue'

import {Cell} from 'vant'
// import ldPay from 'Components/ldPay/index.vue'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { mapGetters } from 'vuex'
import Bussiness from 'Utils/business'
import { isGat, toPayForGat } from 'Utils/gattools';

export default {
  name:'TkCmp',
  components: {
    ldHeader,
    ldButton,
    voyage,
    [Cell.name]:Cell,
    // ldPay,
    ldTabbar
  },
  data(){
    return{
      flights:[],//订单集合
    }
  },
  computed:{
    ...mapGetters({
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
    }),
    orderId(){
      return this.$route.query.orderIds
      // return {'orderIds':'5ac873aaeb1343b9bdae3424e48dc38c'}
    },
    priceFlag(){
      return this.$route.query.priceFlag
    },
    detail(){
      return this.flights[0]||{orderPsgBeanList:[]}
    },
    priceList(){
      return this.tkIntSearchInfo.priceList
    }
  },
  created(){
    this.init()
  },
  methods: {
    init() {
      if (this.priceFlag == 1) {
        this.$dialog.alert({message: '当前预订舱位价格发生变化，系统已自动修改订单，实际价格以订单价格为准!'});
      }
      this.getDetail();
    },
    getDetail() {
      this.$api['tkOrder/orderDetail']({
        id: this.orderId
      }).then(res => {
        let cache = res.data || {};
        this.flights.push(cache);
      });
    },
    cancel() {
      Bussiness.toOrderCancel({orderType: '11004', id: this.orderId});
    },
    sendApproval(detail) {//审批
      this.$router.push({
        path: '/approval/Send',
        query: {orderId: detail.id, orderNo: detail.orderNo, orderType: detail.orderType}
      });
    },
    toPay(orderId) {//支付
      this.orderId = orderId;
      // this.toggle('pay')
      // 关爱通支付
      if (isGat()) {
        return toPayForGat(this.orderId, '11004');
      }
      this.$router.push({path: '/pay/payment', query: {orderType: '11004', orderId: this.orderId}});
    },
    toDetail(orderId) {//去详情
      this.$router.push({path: '/tk/tkOrderDetail', query: {orderId: orderId}});
    },
    toggle(name) {
      this.$refs[name].toggle();
    },
    bock() {
      if (localStorage.getItem('Pagenew') == 1) {
        this.$router.push({path: '/home'});
      } else {
        this.$router.push({path: '/tk/tkQuery'});
      }
    }
  },
  beforeDestroy(){
    this.$store.commit('tkInt/CLEAR_ALL',{})
  },
  filters:{
    getName(arr){
      let nameArr=arr.map(item=>{
        return item.psgName
      })
      return nameArr.join(',')
    }
  }
}
</script>

<style lang="less" scoped>
    .pad-8{
        padding: 8px;
    }
    .pad-b-5{
        padding-bottom: 5px;
    }
    .pad-b-20{
        padding-bottom: 20px;
    }
    .tkCmp{
    }
</style>
